import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import FormatDate from "../../formatdatetime";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import { Navigate, useNavigate } from "react-router-dom";
import { baseurl } from "../../constant";
import Loading from "../../loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MyFundRequest = ({ sendDataToParent }) => {
  const [data, setdata] = useState();
  const [data1, setdata1] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalrecord, settotalrecord] = useState();
  const [startdate, setstartdate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [enddate, setenddate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [keyword, setkeyword] = useState();
  const [status, setstatus] = useState();
  const [active, setactive] = useState(1);
  const [amount, setAmount] = useState();
  const [txnid, settxnId] = useState();
  const [loading, setloading] = useState(false);
  const [datalength, setdatalength] = useState();

  const handleClick = () => {
    setactive();
  };

  const handleDataFromChild = (data) => {
    setactive(data);
  };

  const tableRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Users table",
    sheet: "Users",
  });

  const token = localStorage.getItem("authToken");
  const pageRecord = 50;
  const totalPage = Math.ceil(totalrecord / pageRecord);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  var pages = [];
  const maxvisablepage = 8;
  if (totalPage <= maxvisablepage) {
    for (let i = 1; i <= totalPage; i++) {
      pages.push(i);
    }
  } else {
    if (currentPage <= 3) {
      // Show first 3 pages, then ellipsis, then last page
      pages.push(1, 2, 3, ".......", totalPage);
    } else if (currentPage >= totalPage - 2) {
      // Show first page, then ellipsis, then last 3 pages
      pages.push(1, totalPage - 2, totalPage - 1, totalPage);
    } else {
      // Show first page, ellipsis, current page & its neighbors, ellipsis, last page
      pages.push(
        1,

        currentPage - 1,
        currentPage,
        currentPage + 1,

        totalPage
      );
    }
  }
  const fundRequest = async () => {
    setloading(true);
    const result = await axios.post(baseurl + "requestPostAuth", {
      token: token,
      amount: amount,
      txnid: txnid,
    });
    setdata1(result);
    setactive(1);
    getdata();
    setloading(false);
  };

  // const getdata1 = async () => {
  //   setloading(true);
  //   const result = await axios.post(baseurl + "myRequestAuth", {
  //     token: token,
  //     pageno: currentPage,
  //     pageRecord: pageRecord,
  //     fromDate: startdate.replaceAll('/', '-'),
  //     fromDate: enddate.replaceAll('/', '-'),
  //     keyword: keyword,
  //   });

  //   setdata(result.data);
  //   settotalrecord(result.data.totalRecord);
  //   setCurrentPage(1);
  //   setloading(false);
  // };

  const getdata = async () => {
    setloading(true);
    const result = await axios.post(baseurl + "myRequestAuth", {
      token: token,
      pageno: currentPage,
      pageRecord: pageRecord,
      fromDate: startdate,
      toDate: enddate,
      keyword: keyword,
      status: status,
    });
    setdata(result.data);
    settotalrecord(result.data.totalRecord);
    setdatalength(result.data.data.length);
    setloading(false);
  };
  useEffect(() => {
    getdata();
  }, [currentPage]);
  return (
    <>
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <div>
          {active ? (
            active == 1 && (
              <div className="card shadow ">
                <div className="card-header py-3">
                  <div className="row">
                    <div className="col-sm-12">
                      <h4>
                        <b>My Request List</b>
                      </h4>
                    </div>

                    <div className="col-sm-2">
                      <input
                        type="date"
                        className="form-control datepick"
                        placeholder={startdate}
                        autocomplete="off"
                        name="from_date"
                        id="from_date"
                        value={startdate}
                        onChange={(e) => setstartdate(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-2">
                      <DatePicker
                        className="form-control datepick"
                        selected={startdate}
                        onChange={(date) => setstartdate(date)}
                        dateFormat="yyyy-MM-dd"
                        placeholderText={startdate}
                      />
                    </div>
                    <div className="col-sm-2">
                      {" "}
                      <DatePicker
                        className="form-control datepick"
                        selected={enddate}
                        onChange={(date) => setenddate(date)}
                        dateFormat="yyyy-MM-dd"
                        placeholderText={enddate}
                      />
                    </div>
                    <div className="col-sm-4">
                      <button
                        type="button"
                        className="btn btn-primary"
                        id="searchMyRequestBtn"
                        onClick={() => getdata()}
                      >
                        Search
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleClick}
                        style={{ margin: "5px" }}
                      >
                        Add Request
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-striped"
                      id="myFundRequestDataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Member</th>
                          <th>Request ID</th>
                          <th>Txn ID</th>
                          <th>Amount</th>
                          <th>Datetime</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {datalength > 0 ? (
                          data.data.map((item, index) => (
                            <tr>
                              <td>
                                {(currentPage - 1) * pageRecord + index + 1}
                              </td>
                              <td>
                                {item.name}({item.user_code})
                              </td>
                              <td>{item.request_id}</td>
                              <td>{item.txnid}</td>
                              <td>{item.request_amount}</td>
                              <td>{FormatDate(item.created)}</td>
                              {item.status == 1 && <th>pending</th>}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <th colspan="11" style={{ textAlign: "center" }}>
                              There is no data in table
                            </th>
                          </tr>
                        )}
                      </tbody>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Member</th>
                          <th>Request ID</th>
                          <th>Txn ID</th>
                          <th>Amount</th>
                          <th>Datetime</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                    </table>
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage == 1}
                      style={{
                        padding: "10px 15px",
                        margin: "5px",

                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      previous
                    </button>

                    {pages.map((page, index) => (
                      <button
                        key={index}
                        onClick={() => page !== "..." && handlePageChange(page)}
                        style={{
                          padding: "10px 15px",
                          margin: "5px",
                          backgroundColor:
                            currentPage === page ? "red" : "#f0f0f0",
                          color: currentPage === page ? "#fff" : "#000",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          cursor: page === "..." ? "default" : "pointer",
                          fontWeight: page === "..." ? "bold" : "normal",
                        }}
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    ))}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage == totalPage}
                      style={{
                        padding: "10px 15px",
                        margin: "5px",

                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )
          ) : (
            <div className="card shadow ">
              <div className="card-header py-3">
                <div className="row">
                  <div className="col-sm-12">
                    <h4>
                      <b>Fund Request</b>
                      <button
                        style={{ marginLeft: "700px" }}
                        onClick={() => {
                          setactive(1);
                        }}
                      >
                        Back
                      </button>
                    </h4>
                  </div>

                  <div className="col-sm-2">
                    <h4>Anount</h4>
                    <input
                      type="text"
                      className="form-control datepick"
                      placeholder="Amount"
                      autocomplete="off"
                      name="to_date"
                      value={amount}
                      onChange={(e) => {
                        setAmount(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-sm-2">
                    <h4>Transaction ID</h4>
                    <input
                      type="text"
                      className="form-control"
                      name="keyword"
                      id="keyword"
                      placeholder="Transaction ID"
                      value={txnid}
                      onChange={(e) => {
                        settxnId(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div style={{ marginLeft: "700px" }}>
                  <button onClick={fundRequest}>Submit</button>
                  <button
                    onClick={() => {
                      setactive(1);
                    }}
                  >
                    Cancle
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive"></div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default MyFundRequest;
